import { MioCondominio } from './mioCondominio';
import { AssignmentActivity } from './activity';
import { CondominiumInfo, CondominiumImplant } from './condominium';
import { Provider } from './provider';
import { ForwardDetails } from './forwardAction';

export enum PriorityEnum {
  Bassa = 1,
  Media = 2,
  Alta = 3,
  Urgente = 4
}

export enum AssignmentStateEnum {
  TO_ACCEPT = 1,
  ACCEPTED = 2,
  REFUSED = 3,
  CANCELED = 4,
  DONE_SUCCESS = 5,
  DONE_FAILURE = 6
}

/* eslint-disable @typescript-eslint/indent */
export type Assignment = AssignementDetails &
  MioCondominio &
  CondominiumInfo &
  CondominiumImplant &
  AssignmentActivity &
  Provider &
  ForwardDetails;

type Details = {
  interventoID: number;
  token: string;
  dataCreazione: string;
  amministratoreNome: string;
  stato: AssignmentStateEnum;
  dataPrevista: string;
  attivitaPriorita: PriorityEnum;
  motivazioneChiusura: string;
  motivazioneUltimoCambioData: string;
  dataEsecuzione: string;
};

export type AssignementDetails = Provider &
  Details &
  Pick<AssignmentActivity, 'attivitaOperatore' | 'attivitaReferente' | 'attivitaReferenteContatto'> & {
    ultimoAggiornamento: string;
    nuoviMessaggi: number;
  };

export type AssignmentDisplayData = {
  details: AssignementDetails;
  condominium: CondominiumInfo;
  condominumImplant: CondominiumImplant;
  activity: AssignmentActivity;
  forward: ForwardDetails;
} & MioCondominio;
